import requests from 'app/requests/Order/OrderComments.requests'
import CommentsLog from 'app/shared-components/CommentsLog'

import useGetOrderComments from './hooks/useGetOrderComments'
import useRemoveOrderComment from './hooks/useRemoveOrderComment'

const OrderComment = ({
    orderNumber,
}: {
    orderNumber: string,
}) => {
    const {
        onParamsChange,
        loadData,
        refetch,
    } = useGetOrderComments(orderNumber)

    const deleteComment = useRemoveOrderComment({
        onSuccess: refetch,
    })

    return (
        <CommentsLog
            requestConfigCreate={requests.createComment({
                orderNumber,
            })}
            deleteComment={deleteComment}
            onParamsChange={onParamsChange}
            loadData={loadData}
            refetch={refetch}
        />
    )
}

export default OrderComment
